import { combineReducers } from 'redux'
import evalFormFields from './fields/EvalFormFields/evalFormFields.reducer'
import metadataFields from './fields/MetadataFields/metadataFields.reducer'
import recordingTypeFields from './fields/RecordingTypeFields/recordingTypeFields.reducer'
import surveyNameFields from './fields/SurveyNameFields/surveyNameFields.reducer'
import timeZoneFields from './fields/TimeZoneFields/timeZoneFields.reducer'

export default combineReducers({
  evalForm: evalFormFields,
  metadata: metadataFields,
  recordingType: recordingTypeFields,
  surveyName: surveyNameFields,
  timeZone: timeZoneFields,
})
